// デモ入力を端末・ブラウザの localStorage にだけ一時保存する。
const KEY = "skilllog_demo_draft";

// 保存済みのデモ入力を読み込む。
//   values … 復元する入力（無ければ null）
//   failed … 保存データが壊れていて読めなかったとき true。未保存・localStorage 無効は false
export const loadDemoInput = () => {
  let raw;
  try {
    raw = localStorage.getItem(KEY);
  } catch {
    return { values: null, failed: false };
  }

  if (raw == null) return { values: null, failed: false };

  try {
    const parsed = JSON.parse(raw);
    // プレーンオブジェクト以外（配列・文字列・数値・壊れた JSON）は読み込み失敗扱い
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return { values: parsed, failed: false };
    }
    return { values: null, failed: true };
  } catch {
    return { values: null, failed: true };
  }
};

// デモ入力を保存する。保存できたら true、失敗したら false
export const saveDemoInput = (values) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(values));
    return true;
  } catch {
    return false;
  }
};

export const clearDemoInput = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
};
